import SingleDropdown from "@/components/common/single-dropdown/single-dropdown";
import { selectCategory } from "@/store/slices/category";
import { combineCategoryFilters } from "@/utils/combineCategoryFilters";
import { useRouter } from "next/router";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

const SortFilter = ({ isSearch }: any) => {
  const router = useRouter();
  const categoryState = useSelector(selectCategory);
  const sortFilters = [
    { label: "Relevance", value: "" },
    { label: "Price: Low to High", value: "price-asc" },
    { label: "Price: High to Low", value: "price-desc" },
  ];

  const sortFilterChange = (value: any) => {
    if (isSearch) {
      router.replace(
        {
          pathname: "/jewellery",
          query: {
            ...combineCategoryFilters({
              ...router.query,
              sort: value,
            }),
            q: router.query.q,
            try_it_online: router.query.try_it_online,
          },
        },
        undefined,
        { shallow: true }
      );
      return;
    }
    router.replace(
      {
        pathname: "/jewellery/category/[category]",
        query: {
          category: categoryState.data?.slug,
          ...combineCategoryFilters({
            ...router.query,
            sort: value,
          }),
        },
      },
      undefined,
      { shallow: true }
    );
  };

  const label = useMemo(
    () =>
      sortFilters.find((v) => v.value == (router.query.sort || ""))?.label ||
      "Relevance",
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [router.query.sort]
  );

  return (
    <SingleDropdown
      label={label}
      items={sortFilters}
      onChange={sortFilterChange}
      showSelected
    />
  );
};

export default SortFilter;
